'use client';

import { Suspense, useCallback } from 'react';
import { AuthGuard } from '@/platform/auth/AuthGuard';
import { useAuth } from '@/platform/auth/useAuth';
import { SettingsSuspenseFallback } from '@/platform/layout';
import { SellerConsole } from '@/platform/vendor/SellerConsole';
import { MarketplacePageFrame } from '../MarketplacePageFrame';
import { VendorConnectReturnHandler } from '../VendorConnectReturnHandler';

function MarketplaceSellContent() {
  const { user } = useAuth();

  const refreshCapabilities = useCallback(() => {
    // SellerConsole reloads on mount; hook reserved for connect return handler.
  }, []);

  return (
    <MarketplacePageFrame
      title="Seller dashboard"
      description="Store setup, find listings, orders, and payouts."
    >
      {user && <VendorConnectReturnHandler vendorUserId={user.uid} onReady={refreshCapabilities} />}
      {user && <SellerConsole sellerUserId={user.uid} onCapabilitiesChange={refreshCapabilities} />}
    </MarketplacePageFrame>
  );
}

export function MarketplaceSellPage() {
  return (
    <AuthGuard message="Sign in to manage your seller dashboard.">
      <Suspense fallback={<SettingsSuspenseFallback title="Seller dashboard" />}>
        <MarketplaceSellContent />
      </Suspense>
    </AuthGuard>
  );
}
